var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnnouncement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "#ffffff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0087 0.54636L6.94662 8.19196L8.75835 14.9534L9.54997 15.0177L9.04475 17.4866C8.98708 17.7674 8.99046 18.0572 9.05465 18.3365C9.11884 18.6159 9.24234 18.8781 9.41677 19.1055C9.59121 19.3329 9.81251 19.5202 10.0657 19.6545C10.3188 19.7889 10.5979 19.8673 10.884 19.8843L15.1811 20.1419C15.6609 20.1675 16.1341 20.0209 16.5153 19.7283C16.8965 19.4358 17.1606 19.0166 17.26 18.5465L17.8441 15.692L22.1612 16.0437C22.3208 16.0566 22.4812 16.031 22.6289 15.9691C22.7766 15.9071 22.9072 15.8106 23.0098 15.6876C23.1124 15.5646 23.184 15.4188 23.2185 15.2624C23.253 15.1061 23.2495 14.9437 23.2081 14.789L19.5427 1.10951C19.5012 0.954859 19.423 0.812454 19.315 0.694278C19.2069 0.576102 19.072 0.485613 18.9217 0.430423C18.7713 0.375233 18.6099 0.356957 18.4511 0.377132C18.2922 0.397308 18.1405 0.455344 18.0087 0.54636ZM15.3006 18.146L11.0044 17.8881L11.5578 15.1817L15.8358 15.5303L15.3006 18.146ZM4.89465 15.9887L6.8265 15.4711L5.01477 8.7096L3.08292 9.22724C2.0175 9.51271 1.38322 10.6113 1.6687 11.6767L2.44516 14.5745C2.73064 15.6399 3.82923 16.2742 4.89465 15.9887Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/announcement.8c379c77.svg";
export { ForwardRef as ReactComponent };